import React from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import FloorTabTitle from 'Components/floor/floor-tab-title'

export interface IFriendshipLinkData {
  name: string
  link: string
}

const friendshipLinks = [
  { name: '今日头条', link: 'https://www.toutiao.com/' },
  { name: '爱卡汽车', link: 'http://www.xcar.com.cn/?zoneclick=104597' },
  { name: '58汽车', link: 'https://www.58che.com/' },
  { name: '驾考宝典', link: 'https://www.jiakaobaodian.com/' },
  { name: '网通社汽车', link: 'http://auto.news18a.com/' },
  { name: '360汽车', link: 'https://auto.360.cn/' },
  { name: '新浪汽车', link: 'https://auto.sina.com.cn/' },
  { name: '电动邦', link: 'http://www.diandong.com/' },
  { name: '太平洋汽车', link: 'https://www.pcauto.com.cn/' },
  { name: '车云网', link: 'http://www.cheyun.com/' },
  { name: '盖世汽车', link: 'https://auto.gasgoo.com/' },
  { name: '大众侃车', link: 'http://www.dazhongkanche.com/' },
  { name: '途虎养车', link: 'https://www.tuhu.cn/' },
  { name: '17汽车网', link: 'https://www.17.com/' },
  { name: '虎扑', link: 'https://www.hupu.com/' },
  { name: '驾校一点通', link: 'http://www.jxedt.com/24' },
  { name: '大搜车家选', link: 'https://www.souche.com/index' },
  { name: '24车汽车资讯', link: 'https://www.24che.com/' },
  { name: '车质网', link: 'http://www.12365auto.com/' },
  { name: '车秀网', link: 'https://www.chexiu.com/' },
  { name: '狮桥二手车', link: 'http://www.shiqiaousedcars.com/' },
  { name: '卡车之家', link: 'http://www.360che.com/' },
]

function FriendshipLink() {
  return (
    <div
      className="tw-mt-8 tw-pb-4"
      data-log-view-config={JSON.stringify({
        repeated: true,
      })}
      data-log-view={JSON.stringify({
        event: 'show_event',
        params: {
          page_id: 'page_main_new',
          event_id: 'common_conponent_module',
          module_id: 'related_module',
        },
      })}
    >
      <a href="/links" target="_blank">
        <FloorTabTitle title="友情链接" onTitleClick={() => 0} />
      </a>
      <div className="tw-flex tw-flex-wrap">
        {friendshipLinks.map((friendshipLink: IFriendshipLinkData) => {
          return (
            <a
              className="tw-mb-8 tw-mr-8"
              href={friendshipLink.link}
              key={friendshipLink.name}
              target={'_blank'}
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  page_id: 'page_main_new',
                  event_id: 'related_module_company_link',
                  module_id: 'related_module',
                  button_name: friendshipLink.name,
                })
              }}
            >
              {friendshipLink.name}
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default FriendshipLink
